<template>
  <section>
    <div class="card">
      <header class="header-card">
        <p> {{ $t('editionCommande.ordreTravail.title')}} </p>
      </header>
      <div class="card-content">
        <v-client-table
          :columns="columns"
          :options="options"
          :data="ordreTravails"
          ref="tableOts">
          <template #code="{ row }">
            <router-link-blank
              v-if="row.id"
              :to="{ name: 'c.logistique.ordre_travail-tech', params: { id: row.id }}"
              :message="row.code ? row.code : null"
              class="lien">
            </router-link-blank>
          </template>
          <template #etat="{ row }">
            {{ $t(getLibelleEtat(row.etat)) }}
          </template>
          <template slot="adresse" slot-scope="props" v-if="props.row.otPatrimoine">
            {{ adresse(props.row.otPatrimoine.adresse) }}
          </template>
          <template slot="ville" slot-scope="props" v-if="props.row.otPatrimoine">
            {{ props.row.otPatrimoine.adresse.ville }}
          </template>
          <template slot="codePostal" slot-scope="props" v-if="props.row.otPatrimoine">
            {{ props.row.otPatrimoine.adresse.codePostal }}
          </template>
        </v-client-table>
      </div>
    </div>
  </section>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import {
  NO_PER_PAGE_VALUE,
  NO_PAGINATION,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import {
  LIST_ETAT_OT_TECH,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';

export default {
  name: 'informatioOts',
  props: {
    ordreTravails: {
      type: Array,
      required: false,
    },
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          etat: this.$t('detailBonExpedition.table.etat'),
          ville: this.$t('detailBonExpedition.table.ville'),
          code: this.$i18n.t('detailBonExpedition.table.code'),
          adresse: this.$t('detailBonExpedition.table.adresse'),
          codePostal: this.$t('detailBonExpedition.table.codePostal'),
          'typeOt.libelle': this.$i18n.t('detailBonExpedition.table.type'),
        },
        filterable: false,
        pagination: { show: false },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        sortable: [],
      };
    },
    columns() {
      return ['code', 'typeOt.libelle', 'etat', 'adresse', 'codePostal', 'ville'];
    },
  },
  methods: {
    getLibelleEtat(etat) {
      const etatFind = LIST_ETAT_OT_TECH.find((dc) => dc.code === etat);
      return etatFind ? etatFind.libelle : '';
    },
    adresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
  },
};
</script>
